import { getSettings } from '../helpers/session';
const math = require('mathjs');

export class Unit {
    static unitObj = null;
    constructor() {
        this.unitInfo = null;
        this.setUnit = this.setUnit.bind(this);
        this.toArea = this.toArea.bind(this);
        this.toSpeed = this.toSpeed.bind(this);
        this.toWeight = this.toWeight.bind(this);
        this.toDistance = this.toDistance.bind(this);
        this.fromArea = this.fromArea.bind(this);
        this.fromSpeed = this.fromSpeed.bind(this);
        this.fromWeight = this.fromWeight.bind(this);
        this.fromDistance = this.fromDistance.bind(this);
    }

    static getInstance() {
        if (!this.unitObj) this.unitObj = new Unit();
        if (!this.unitObj.unitInfo) this.unitObj.setUnit(getSettings());
        return this.unitObj;
    }

    setUnit(unit) {
        this.unitInfo = unit;
    }

    toFixedOf(value, fixedOf) {
        return !isNaN(value) && !isNaN(fixedOf) ? parseFloat(parseFloat(value).toFixed(fixedOf)) : value;
    }

    toArea(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("areaGetExp") && this.unitInfo.areaGetExp) {
            convertValue = math.eval(this.unitInfo.areaGetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    toSpeed(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("speedGetExp") && this.unitInfo.speedGetExp) {
            convertValue = math.eval(this.unitInfo.speedGetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    toWeight(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("weightGetExp") && this.unitInfo.weightGetExp) {
            convertValue = math.eval(this.unitInfo.weightGetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    toDistance(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("distanceGetExp") && this.unitInfo.distanceGetExp) {
            convertValue = math.eval(this.unitInfo.distanceGetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    toRoundOfArea(value) {
        return roundOfAcres(this.toArea(value));
    }

    toRoundOfSpeed(value) {
        return roundOfSpeed(this.toSpeed(value));
    }

    toRoundOfDistance(value) {
        return this.toDistance(value, 2);
    }

    toRoundOfWeight(value, isFormat) {
        const weight = this.toWeight(value, 2);
        return isFormat ? this.formatNumber(weight) : weight;
    }

    fromArea(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("areaSetExp") && this.unitInfo.areaSetExp) {
            convertValue = math.eval(this.unitInfo.areaSetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    fromSpeed(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("speedSetExp") && this.unitInfo.speedSetExp) {
            convertValue = math.eval(this.unitInfo.speedSetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    fromWeight(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("weightSetExp") && this.unitInfo.weightSetExp) {
            convertValue = math.eval(this.unitInfo.weightSetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    fromDistance(value, fixedOf) {
        value = isNaN(Number(value)) ? 0 : Number(value);
        let convertValue = value;
        if (this.unitInfo && this.unitInfo.hasOwnProperty("distanceSetExp") && this.unitInfo.distanceSetExp) {
            convertValue = math.eval(this.unitInfo.distanceSetExp.replace('defaultvalue', value));
        }
        return this.toFixedOf(convertValue, fixedOf);
    }

    formatNumber(num) {
        return num && num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    formatNumberToSmallScale = (number) => {
        if ((number / math.pow(10, 9)) >= 1) return `${this.formatNumber(this.toFixedOf(number / math.pow(10, 9), 2))}B`
        else if ((number / math.pow(10, 6)) >= 1) return `${this.formatNumber(this.toFixedOf(number / math.pow(10, 6), 2))}M`
        else if ((number / math.pow(10, 3)) >= 1) return `${this.formatNumber(this.toFixedOf(number / math.pow(10, 3), 2))}K`
        return number;
    };
}

export const roundOfAcres = acres => {
    return (acres > 0 && acres < 1) ? parseFloat(acres.toFixed(2)) : parseFloat(roundOfWithSlab(acres).toFixed(2));
};

export const roundOfSpeed = speed => {
    speed = Number(speed) ? parseFloat(speed) : 0;
    return (speed > 15 ? Math.round(speed) : parseFloat(speed.toFixed(2)));
};

export const roundOfDays = (days) => {
    return Math.round(days);
};

export const roundOfWithSlab = num => {
    const n = Math.abs(num);
    const pre = n - Math.floor(n);
    let round = 0;
    if (pre <= 0.3) round = 0;
    else if (pre <= 0.8) round = 0.5;
    else if (pre > 0.8) round = 1;
    return Math.floor(num) + round;
};

export const quarterOfNumber = number => {
    if (isNaN(number) || number === 0) return number;
    const numArr = (number + "").split(".");
    if (numArr.length > 1) {
        const decimalNumber = numArr[1];
        const ceilNumber = Math.ceil(decimalNumber / 25);
        const quarterNumber = (ceilNumber * 25);
        return parseFloat(`${numArr[0]}.${quarterNumber}`);
    }
    return number;
};

export const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export const toMilesPerHour = (value) => {
    let convertValue = value && !isNaN(value) ? value : 0;
    convertValue = math.eval(value * 2.23694);
    return convertValue;
}
